import React from "react";

const Skills = () => {
  return (
    <>
      {/* <h1 className="text-lg md:text-3xl p-4 md:ml-12 tracking-[8px] font-bold">
        Skills
      </h1> */}
      <div id="skills-container" className="p-4 md:ml-12 pb-2">
        <h4 className="text-md md:text-xl tracking-[4px] underline underline-offset-4 font-semibold">
          COMPUTING
        </h4>
        <p className="text-neutral-500 py-6 text-[10px] md:text-[16px]">
          Python (Pandas, NumPy), C++, SQL, JavaScript
        </p>
        <h4 className="text-md md:text-xl tracking-[4px] underline underline-offset-4 font-semibold">
          Language
        </h4>
        <p className="text-neutral-500 py-6 text-[10px] md:text-[16px]">
          {" "}
          Cantonese (Native), English (Fluent) and Mandarin (Conversational)
        </p>
      </div>
    </>
  );
};

export default Skills;
